import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import camelCase from 'lodash/camelCase';

import { withContainer } from 'core/cache';

import Tabs from '../components/tabs';

const TabsContainer = ({
  className = '',
  direction = 'horizontal',
  id = '',
  initialTabId = '',
  match: { path, url },
  onClick = () => {},
  queryParamsToPersist = [],
  shouldRedirectOnInvalidTab = false,
  shouldRenderAll = true,
  shouldUpdateInitialUrl = false,
  tabs = [],
  variant = 'admin',
}) => {
  const paramName = camelCase(`${id} tabId`);

  return (
    <Route
      path={`${path}/:${paramName}?`}
      render={({ match }) => {
        const paramValue = match.params[paramName];
        const targetId = paramValue || initialTabId || tabs[0]?.id;

        if (shouldUpdateInitialUrl && !paramValue) {
          return <Redirect to={`${url}/${targetId}`} />;
        }

        if (shouldRedirectOnInvalidTab && paramValue) {
          const validTabIds = tabs.map((tab) => tab.id);
          const fallbackId = initialTabId || tabs[0]?.id;

          if (!validTabIds.includes(paramValue) && fallbackId) {
            return <Redirect to={`${url}/${fallbackId}`} />;
          }
        }

        return (
          <Tabs
            activeId={targetId}
            className={className}
            isVertical={direction === 'vertical'}
            onClick={onClick}
            queryParamsToPersist={queryParamsToPersist}
            shouldRenderAll={shouldRenderAll}
            tabs={tabs}
            url={url}
            variant={variant}
          />
        );
      }}
    />
  );
};

TabsContainer.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  id: PropTypes.string,
  initialTabId: PropTypes.string,
  match: PropTypes.shape({ path: PropTypes.string, url: PropTypes.string }).isRequired,
  onClick: PropTypes.func,
  queryParamsToPersist: PropTypes.arrayOf(PropTypes.string),
  shouldRedirectOnInvalidTab: PropTypes.bool,
  shouldRenderAll: PropTypes.bool,
  shouldUpdateInitialUrl: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      body: PropTypes.node,
    }),
  ),
  variant: PropTypes.oneOf(['admin', 'student']),
};

export default withContainer(TabsContainer, { hasRouter: true });
